<template>
  <div>
    <input
      type="hidden"
      name="file_name"
      ref="file_name"
      :value="this.fileName"
    />
    <input
      type="hidden"
      name="file_path"
      ref="file_path"
      :value="this.filePath"
    />
    <div class="custom-file">
      <input
        v-if="
          !this.stream ||
          (this.stream && !this.stream.is_active && !this.stream.is_finished)
        "
        name="image"
        type="file"
        id="imageFile"
        class="upload-file-input custom-file-input"
        accept="image/*"
        :required="required"
        @change="setImage"
      />
      <label for="imageFile" class="custom-file-label">Select new image</label>
    </div>

    <!-- Cropper container -->
    <div
      v-if="getImage"
      class="my-3 d-flex align-items-center justify-content-center mx-auto"
    >
      <vue-cropper
        v-if="imageSrc"
        class="w-50"
        ref="cropper"
        :aspectRatio="aspectRatio"
        :initialAspectRatio="aspectRatio"
        :guides="true"
        :src="imageSrc"
      ></vue-cropper>

      <!-- Image previewer -->
      <img
        v-else
        :src="getImage"
        class="
          img-thumbnail
          cropper-img
          col-6 col-6
          ml-auto
          mr-auto
          d-block
          p-0
        "
      />
    </div>
    <button v-if="this.imageSrc" class="btn btn-black" @click="cropImage">
      Crop
    </button>
    <button
      v-if="uploadedImg && this.croppedImageSrc && this.imageSrc"
      class="btn btn-black"
      @click="resetImage"
    >
      Reset
    </button>
    <button
      v-if="getImage && !this.imageSrc"
      class="btn btn-black"
      @click="recropImage"
    >
      Edit
    </button>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { v4 as uuidv4 } from "uuid";

export default {
  props: ["image", "stream", "fixedRatio", "required"],
  components: {
    VueCropper,
  },
  data: function () {
    return {
      uploadedImg: (this.image && this.image.original_path) || "",
      imageSrc: "",
      croppedImageSrc: "",
      croppedImageValue: "",
      fileName: "",
      filePath: "",
    };
  },
  computed: {
    computed() {
      let temp = this.num + 1;
      this.$emit("onNumChange", temp);
      return temp;
    },

    aspectRatio() {
      return this.fixedRatio ? 16 / 9 : 5 / 4;
    },

    getImage() {
      return (
        this.croppedImageSrc ||
        (this.image && this.image.original_path) ||
        this.imageSrc
      );
    },
  },
  methods: {
    setImage: function (e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      if (file.size > 1024 * 20000) {
        e.preventDefault();
        alert("File too big (> 20MB)");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imageSrc = event.target.result;
          this.uploadedImg = event.target.result;
          this.s3Upload(e.target, event.target.result);
          this.setImgInCropper(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },

    setImgInCropper(img) {
      if (this.$refs.cropper !== undefined) {
        // Rebuild cropperjs with the updated source
        this.$refs.cropper.replace(img);
      }
    },

    cropImage(e) {
      e.preventDefault();
      // Get image data for post processing, e.g. upload or setting image src
      this.croppedImageSrc = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.imageSrc = "";
      this.s3Upload(
        e.target,
        this.$refs.cropper.getCroppedCanvas().toDataURL()
      );
    },

    recropImage(e) {
      e.preventDefault();
      this.imageSrc = this.getImage;
    },

    resetImage(e) {
      e.preventDefault();
      this.imageSrc = this.uploadedImg;
      this.croppedImageSrc = this.uploadedImg;
      this.setImgInCropper(this.uploadedImg);
    },

    s3Upload: function (element, elementSrc = null) {
      this.$parent.isDisabledSubmitButton(true);

      if (
        elementSrc != null ||
        (document.querySelector(".cropper-img") !== null &&
          document.querySelector(".cropper-img").src)
      ) {
        let source = "",
          typeOfFile = "image/png";

        if (elementSrc != null) {
          source = elementSrc;
        } else {
          source = document.querySelector(".cropper-img").src;
        }
        let firstPart = source.split(":")[1],
          extension = "png";
        typeOfFile = firstPart.split(";")[0];
        extension = typeOfFile.split("/")[1];

        fetch(source)
          .then((res) => res.blob())
          .then((blob) => {
            const simulatedFile = new File([blob], uuidv4() + "." + extension, {
              type: typeOfFile,
            });

            Vapor.store(simulatedFile, {
              progress: (progress) => {
                // console.log(Math.round(progress * 100));
              },
            }).then((response) => {
              this.fileName = response.uuid + "." + response.extension;
              this.filePath = response.key;
              this.$parent.isDisabledSubmitButton(false);
            });
          });
      }
    },
  },
};
</script>
